import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getValidationRuleStyles = () => {
  return StyleSheet.create({
    ruleContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    iconStyle: {
      marginRight: tokens.spacing.SPACING_8
    }
  });
};